import {
  AppUpdate,
  AppUpdateAvailability,
} from '@capawesome/capacitor-app-update'

export const useNative = () => {
  const isUpdateAvailable = async () => {
    const result = await AppUpdate.getAppUpdateInfo()

    if (result.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE) {
      return true
    }
    return false
  }

  return {
    openStore: AppUpdate.openAppStore,
    isUpdateAvailable,
  }
}
